import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  useMediaQuery,
  useTheme,
  Stack,
  IconButton,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaTiktok, FaEnvelope, FaHeadset } from "react-icons/fa";

const ContactPage = () => {
  useEffect(() => {
    document.title = "CMSOLTEC | Contacto";
    window.scrollTo(0, 0);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ backgroundColor: "#ffffff", py: 6, px: { xs: 2, md: 8 }, minHeight: "100vh" }}>
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.4rem" },
            fontWeight: 700,
            color: "#ff6f00",
            mb: 4,
            textAlign: "center",
          }}
        >
          ¿Necesitas ayuda? ¡Estamos para apoyarte!
        </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: 700,
            margin: "0 auto",
            fontSize: "1.1rem",
            textAlign: "center",
            color: "#555",
            mb: 6,
          }}
        >
          Comunícate con nuestro equipo para resolver tus dudas, recibir asesoría técnica o conocer más sobre nuestros productos. 
          Te responderemos lo más pronto posible.
        </Typography>
      </motion.div>

      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={4} display="flex">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
            style={{ flex: 1, display: 'flex' }}
          >
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, backgroundColor: "#f9f9f9", width: '100%' }}>
              <Stack spacing={2} alignItems="center" justifyContent="space-between" sx={{ height: "100%" }}>
                <FaWhatsapp size={36} color="#25D366" />
                <Typography variant="h6" fontWeight={600}>
                  Escríbenos por WhatsApp
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center", color: "#666" }}>
                  Atención directa y personalizada. Resolvemos tus dudas en tiempo real.
                </Typography>
                <Typography variant="body2" fontWeight={500} sx={{ color: "#333" }}>
                  (+593) 98 481 3777
                </Typography>
                <Button
                  variant="outlined"
                  href="https://wa.me/593984813777"
                  target="_blank"
                  sx={{ borderColor: "#25D366", color: "#25D366", fontWeight: 600 }}
                >
                  Iniciar Chat
                </Button>
              </Stack>
            </Paper>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={4} display="flex">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            style={{ flex: 1, display: 'flex' }}
          >
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, backgroundColor: "#f9f9f9", width: '100%' }}>
              <Stack spacing={2} alignItems="center" justifyContent="space-between" sx={{ height: "100%" }}>
                <FaEnvelope size={36} color="#ff6f00" />
                <Typography variant="h6" fontWeight={600}>
                  Envíanos un correo
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center", color: "#666" }}>
                  Contáctanos por email y te responderemos lo antes posible.
                </Typography>
                <Typography variant="body2" fontWeight={500} sx={{ color: "#333" }}>
                  info@cmsoltec.com
                </Typography>
                <Button
                  variant="outlined"
                  href="mailto:info@cmsoltec.com"
                  sx={{ borderColor: "#ff6f00", color: "#ff6f00", fontWeight: 600 }}
                >
                  Escribir Email
                </Button>
              </Stack>
            </Paper>
          </motion.div>
        </Grid>

        {/* Redes Sociales */}
        <Grid item xs={12} md={4} display="flex">
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.7 }}
            style={{ flex: 1, display: 'flex' }}
          >
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3, backgroundColor: "#f9f9f9", width: '100%' }}>
              <Stack spacing={2} alignItems="center" justifyContent="space-between" sx={{ height: "100%" }}>
                <FaHeadset size={36} color="#1976d2" />
                <Typography variant="h6" fontWeight={600}>
                  Redes Sociales y Soporte
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center", color: "#666" }}>
                  También puedes encontrarnos y escribirnos en nuestras redes:
                </Typography>
                <Stack direction="row" spacing={3}>
                  <IconButton
                    href="https://www.facebook.com/cmsoltec/"
                    target="_blank"
                    sx={{ backgroundColor: "#1877F2", color: "#fff", '&:hover': { backgroundColor: "#145DBF" } }}
                  >
                    <FaFacebookF size={20} />
                  </IconButton>
                  <IconButton
                    href="https://www.instagram.com/cmsoltec/"
                    target="_blank"
                    sx={{ backgroundColor: "#E1306C", color: "#fff", '&:hover': { backgroundColor: "#C12C60" } }}
                  >
                    <FaInstagram size={20} />
                  </IconButton>
                  <IconButton
                    href="https://www.tiktok.com/@cmsoltec?lang=es"
                    target="_blank"
                    sx={{ backgroundColor: "#000", color: "#fff", '&:hover': { backgroundColor: "#222" } }}
                  >
                    <FaTiktok size={20} />
                  </IconButton>
                </Stack>
              </Stack>
            </Paper>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactPage;
